import { Box } from "@mui/material";
import { BrazilIcon } from "../assets";

export default function BrazilImage(){
    return (
        <Box component="img" src={BrazilIcon} />
    );
}